import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import getApiInstance from "../services/api";
import { subDays, format } from "date-fns";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { DateTimeToBr } from "../hooks/Utils";
import TransactionDetails from "./TransactionDetails";

export default function RecentTransactions() {
  const { system } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  const handleExpandClick = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };
  useEffect(() => {
    async function fetchTransactions() {
      setLoading(true);
      setError("");
      try {
        const api = getApiInstance(system);
        const endDate = new Date();
        const startDate = subDays(endDate, 3);
        // Ajuste o endpoint conforme a lógica do seu sistema
        const response = await api.post("/transactions", {
          dateRange: {
            startDate: format(startDate, "yyyy-MM-dd"),
            endDate: format(endDate, "yyyy-MM-dd"),
          },
        });
        setTransactions(response.data || []);
      } catch (err) {
        setError("Erro ao buscar transações recentes.");
      } finally {
        setLoading(false);
      }
    }
    fetchTransactions();
  }, [system]);

  if (loading) return <CircularProgress size={28} />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!transactions.length)
    return (
      <Typography>Nenhuma transação encontrada nos últimos 3 dias.</Typography>
    );

  return (
    <List>
      {transactions.slice(0, 4).map((tx) => (
        <div key={tx.Id || tx.NumOrdem}>
          <ListItem
            alignItems="flex-start"
            secondaryAction={
              <IconButton
                edge="end"
                onClick={() => handleExpandClick(tx.Id || tx.NumOrdem)}
              >
                {expandedId === (tx.Id || tx.NumOrdem) ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )}
              </IconButton>
            }
          >
            <ListItemText
              primary={tx.Nome}
              secondary={
                <>
                  <span>{`${tx.IDCobranca || tx.Id || tx.NumOrdem}`}</span>
                  <br />
                  <span>
                    {`${DateTimeToBr(tx.Data || tx.data)} | 
                          ${tx.CPF || ""} | 
                          ${tx.Forma || ""} | 
                          ${tx.Valor?.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })} | 
                          ${tx.Status || ""}`}
                  </span>
                </>
              }
            />
          </ListItem>
          <Collapse
            in={expandedId === (tx.Id || tx.NumOrdem)}
            timeout="auto"
            unmountOnExit
          >
            <TransactionDetails transaction={tx} />
          </Collapse>
        </div>
      ))}
    </List>
  );
}
